import React, { useState } from "react";
import { Link } from "react-router-dom";

const ReturnRequest = () => {
  const [orderInput, setOrderInput] = useState("");
  const [reason, setReason] = useState("");
  const [details, setDetails] = useState("");
  const [submitted, setSubmitted] = useState(null);
  const [error, setError] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    setError("");
    setSubmitted(null);

    const pattern = /^#[0-9]{5}$/; // must start with # + 5 digits
    if (!pattern.test(orderInput.trim())) {
      setError("Please enter a valid order ID (e.g., #12345).");
      return;
    }

    if (!reason) {
      setError("Please select a reason for return.");
      return;
    }

    // Fake response simulation
    setTimeout(() => {
      setSubmitted({
        id: orderInput.trim(),
        date: new Date().toLocaleDateString(),
        time: new Date().toLocaleTimeString(),
        reason,
        details: details || "No additional details provided.",
        status: "Return Request Submitted",
      });
    }, 700);
  };

  return (
    <section className="order-track-section py-80">
      <div className="container text-center">
        <h2 className="order-track-title fw-bold mb-12">
          Return or Replace Your Order
        </h2>
        <p className="order-track-subtitle text-muted mb-4">
          Enter your order ID and reason for return below
        </p>
        <p className="order-track-welcome text-gray-700 mb-40">
          You can easily submit a return request for your recent orders.
        </p>

        <div className="order-track-box mx-auto p-32 rounded-8 shadow-sm border">
          <div className="order-track-header d-flex align-items-center mb-20">
            <i className="ph ph-arrow-counter-clockwise text-main me-2 text-xl"></i>
            <h5 className="fw-semibold mb-0 text-dark">Return Request Form</h5>
          </div>

          <form
            onSubmit={handleSubmit}
            className="order-track-form d-flex flex-column gap-16 text-start"
          >
            {/* Order ID */}
            <input
              type="text"
              value={orderInput}
              onChange={(e) => setOrderInput(e.target.value)}
              className="order-track-input rounded-8 px-16 py-12"
              placeholder="Enter order ID (e.g., #12345)"
            />

            {/* Reason for Return */}
            <select
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              className="order-track-input rounded-8 px-16 py-12"
            >
              <option value="">Select Reason for Return</option>
              <option value="Received Damaged Product">
                Received Damaged Product
              </option>
              <option value="Wrong Item Received">Wrong Item Received</option>
              <option value="Product Not as Described">
                Product Not as Described
              </option>
              <option value="Missing Accessories or Parts">
                Missing Accessories or Parts
              </option>
              <option value="Defective or Malfunctioning Product">
                Defective or Malfunctioning Product
              </option>
              <option value="Other">Other</option>
            </select>

            {/* Additional Details */}
            <textarea
              rows="4"
              value={details}
              onChange={(e) => setDetails(e.target.value)}
              className="order-track-input rounded-8 px-16 py-12"
              placeholder="Additional details (optional)"
            />

            <button
              type="submit"
              className="order-track-btn rounded-8 fw-semibold"
            >
              Submit Return Request
            </button>
          </form>

          {error && <p className="text-danger mt-16 fw-semibold">{error}</p>}

          <p className="order-track-hint text-gray-600 mt-16">
            You can find your order ID in your confirmation email. Try with
            something like <strong>#54321</strong>.
          </p>

          {submitted && (
            <div className="mt-32 border-top pt-24 text-start">
              <h6 className="text-dark fw-semibold mb-8">
                Return Details for {submitted.id}
              </h6>
              <p className="text-gray-700 mb-2">
                <strong>Status:</strong> {submitted.status}
              </p>
              <p className="text-gray-700 mb-2">
                <strong>Reason:</strong> {submitted.reason}
              </p>
              <p className="text-gray-700 mb-2">
                <strong>Additional Details:</strong> {submitted.details}
              </p>
              <p className="text-gray-600">
                <strong>Submitted On:</strong> {submitted.date} at{" "}
                {submitted.time}
              </p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default ReturnRequest;
